<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
body{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
#app {
  height: 100vh;
  background-color: #e6e6e6;
  font-family: sans-serif;
}
.main_box{
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  background-color: #fff;
}
.el-main{
  padding: 10px !important;
}

</style>